import { isSupportedLanguage, type SupportedLanguage } from './supported-languages'

export function getSupportedBrowserLanguage(): SupportedLanguage | undefined {
  const languageCode = navigator.language.substring(0, 2)
  if (isSupportedLanguage(languageCode)) {
    return languageCode
  }
}
